import BarChart from './barChart.js';
export default BarChart;
